import { bool, object } from 'prop-types';
import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { getUserId, cookieJarConstants } from 'dibs-cookie-jar';
import AppStoreButton from 'dibs-vg/dist/react/app-store';

import LinkRow from './LinkRow/LinkRow';
import SocialLinkRow from './SocialLinkRow/SocialLinkRow';
import CurrencySelector from './CurrencySelector/CurrencySelector';

import { primaryLinks, siteLinks, socialLinks, legalLinks, sitemapLinks, appLink } from './links';

import style from './Footer-style.scss';

class Footer extends React.Component {

    componentDidMount() {
        this.updateUserState();
    }

    componentDidUpdate(prevProps) {
        if (this.props.updateUserState && !prevProps.updateUserState) {
            this.updateUserState();
        }
    }

    updateUserState() {
        const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);
        const hasUserId = !!userId;

        if (hasUserId) {
            const refetchVariables = () => ({
                userId: userId,
                hasUserId
            });

            this.props.relay.refetch(refetchVariables, null);
        }
    }

    render() {
        return (
            <footer className={style.footer}>
                <LinkRow type="primary" items={primaryLinks} />
                <div className={style.divider} />
                <LinkRow type="site" items={siteLinks} />
                <SocialLinkRow items={socialLinks} />
                <LinkRow type="legal" items={legalLinks} />

                <div className={style.row}>
                    <div className={style.cell}>
                        <CurrencySelector
                            viewer={this.props.viewer}
                            user={this.props.viewer.user || null}
                        />
                    </div>
                    <div className={style.cell}>
                        <a className={style.appStoreLink} href={appLink.href} data-tn={appLink.dataTn}>
                            <AppStoreButton />
                        </a>
                    </div>
                </div>

                <LinkRow type="sitemap" items={sitemapLinks} />
            </footer>
        );
    }
}

Footer.propTypes = {
    relay: object,
    updateUserState: bool,
    viewer: object
};

const mapStateToProps = (state) => {
    const updateUserState = get(state, 'header.updateUserState');

    return { updateUserState };
};

Footer = createRefetchContainer(
    connect(mapStateToProps)(Footer),
    {
        viewer: graphql`
            fragment Footer_viewer on Viewer {
                user(userId: $userId) @include(if: $hasUserId) {
                    serviceId
                    ...CurrencySelector_user
                }
                ...CurrencySelector_viewer
            }
        `
    },
    graphql.experimental`
        query FooterRefetchQuery(
            $userId: String!
            $hasUserId: Boolean!
        ) {
            viewer {
                ...Footer_viewer
            }
        }
    `
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx